import React from 'react';
import { Phase } from "./Walkthrough";
import { commentary, embed, IWalkthroughArgs, setInitialCamera } from "./WalkthroughTools";
import s from './Walkthrough.module.scss';
import { Vec3 } from '@/src/utils/vector';

let minGptLink = 'https://github.com/karpathy/minGPT';
let pytorchLink = 'https://pytorch.org/';
let andrejLink = 'https://karpathy.ai/';
let zeroToHeroLink = 'https://karpathy.ai/zero-to-hero.html';

export function walkthrough01_Prelim(args: IWalkthroughArgs) {
    let { state, walkthrough: wt } = args;

    if (wt.phase !== Phase.Intro_Prelim) {
        return;
    }

    setInitialCamera(state, new Vec3(184.744, 0.000, -636.820), new Vec3(296.000, 16.000, 13.500));

    let c0 = commentary(wt, null, 0)`在深入算法之前，先了解本演示的范围。

本指南展示的是 _推理_，而不是训练。模型权重已经预先训练完成；现在利用这些权重计算输出，整个推理过程直接在浏览器中运行。

GPT 是“生成式预训练 Transformer”的缩写，可以理解为根据上下文预测下一个词元的模型。GPT 系列于 2018 年提出，GPT-2、GPT-3 等模型都采用这一类结构。本演示展示的是简化模型，不能代表所有现代大模型的具体实现。

本指南受到开源项目 ${embedLink('minGPT', minGptLink)} 的启发。它是由 ${embedLink('Andrej Karpathy', andrejLink)} 使用 ${embedLink('PyTorch', pytorchLink)} 编写的精简 GPT 实现。其视频课程 ${embedLink("Neural Networks: Zero to Hero", zeroToHeroLink)} 和 minGPT 项目为本指南提供了重要参考，本演示的字母排序模型也来自该项目。

现在开始逐层探索！`;

}

export function embedLink(a: React.ReactNode, href: string) {
    return embedInline(<a className={s.externalLink} href={href} target="_blank" rel="noopener noreferrer">{a}</a>);
}

export function embedInline(a: React.ReactNode) {
    return { insertInline: a };
}


// Another similar model is BERT (bidirectional encoder representations from transformers), a "context-aware text encoder" commonly
// used for tasks like document classification and search.  Newer models like Facebook's LLaMA (large language model architecture), continue to use
// a similar transformer architecture, albeit with some minor differences.
